var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSmoking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property Detail - Pricng detail closed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3741,
    transform: "translate(-541.9 -1817.9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Primary",
    d: "M3.00273 4.0656L12.134 13.1969C11.0246 14.075 9.62461 14.6 8.09961 14.6C4.50898 14.6 1.59961 11.6906 1.59961 8.09998C1.59961 6.57498 2.12461 5.17185 3.00273 4.0656ZM8.15898 7.09998L4.06523 3.0031C5.17461 2.12498 6.57461 1.59998 8.09961 1.59998C11.6902 1.59998 14.5996 4.50935 14.5996 8.09998C14.5996 9.62498 14.0746 11.0281 13.1965 12.1344L11.159 10.1H12.5996C12.8746 10.1 13.0996 9.87498 13.0996 9.59998V7.59998C13.0996 7.32498 12.8746 7.09998 12.5996 7.09998H8.15898ZM9.15898 8.09998H12.0996V9.09998H10.159L9.15898 8.09998ZM8.09961 16.1C10.2213 16.1 12.2562 15.2571 13.7565 13.7568C15.2568 12.2565 16.0996 10.2217 16.0996 8.09998C16.0996 5.97824 15.2568 3.94341 13.7565 2.44312C12.2562 0.94283 10.2213 0.0999756 8.09961 0.0999756C5.97788 0.0999756 3.94305 0.94283 2.44276 2.44312C0.942464 3.94341 0.0996094 5.97824 0.0996094 8.09998C0.0996094 10.2217 0.942464 12.2565 2.44276 13.7568C3.94305 15.2571 5.97788 16.1 8.09961 16.1ZM8.59961 3.09998C8.32461 3.09998 8.09961 3.32498 8.09961 3.59998C8.09961 4.4281 8.77148 5.09998 9.59961 5.09998H10.5996C10.8746 5.09998 11.0996 5.32498 11.0996 5.59998C11.0996 5.87498 11.3246 6.09998 11.5996 6.09998C11.8746 6.09998 12.0996 5.87498 12.0996 5.59998C12.0996 4.77185 11.4277 4.09998 10.5996 4.09998H9.59961C9.32461 4.09998 9.09961 3.87498 9.09961 3.59998C9.09961 3.32498 8.87461 3.09998 8.59961 3.09998ZM3.59961 7.09998C3.32461 7.09998 3.09961 7.32498 3.09961 7.59998V9.59998C3.09961 9.87498 3.32461 10.1 3.59961 10.1H7.62461L4.62461 7.09998H3.59961Z",
    fill: "#01152E",
    stroke: "white",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSmoking);
export default __webpack_public_path__ + "static/media/no-smoking.87575b0f50e402689c7b36cb7ba1a09d.svg";
export { ForwardRef as ReactComponent };